var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMfhsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 223,
    height: 53,
    viewBox: "0 0 223 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_319_774)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.08 46.07L76.97 6.63H83.89L94.83 25.25L105.59 6.63H112.51L114.4 46.07H107.13L105.83 18.75L96.37 34.83H92.88L83.36 19.16L82.06 46.06H75.08V46.07Z",
    fill: "#424142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.91 46.07V6.63H147.39V13.19H129.36V23.42H142.84V30.04H129.36V46.06H121.91V46.07Z",
    fill: "#424142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.191 46.07V6.63H160.641V22.48H180.211V6.63H187.661V46.07H180.211V29.1H160.641V46.07H153.191Z",
    fill: "#424142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.33 39.7399L198.53 34.9499C199.2 35.6599 199.99 36.4299 200.9 37.2599C201.81 38.0899 202.89 38.7999 204.15 39.3899C205.41 39.9799 206.87 40.2799 208.53 40.2799C210.86 40.2799 212.58 39.7399 213.7 38.6499C214.82 37.5699 215.39 36.2899 215.39 34.8399C215.39 33.1499 214.7 31.8199 213.32 30.8799C211.94 29.9299 209.48 29.1299 205.93 28.4599C203.52 27.9899 201.54 27.1799 199.99 26.0399C198.43 24.8999 197.27 23.5299 196.5 21.9299C195.73 20.3299 195.35 18.6699 195.35 16.9299C195.35 14.9199 195.85 13.0599 196.86 11.3399C197.87 9.62995 199.38 8.23995 201.41 7.16995C203.44 6.09995 205.99 5.56995 209.07 5.56995C211.16 5.56995 212.95 5.79995 214.45 6.24995C215.95 6.69995 217.2 7.25995 218.2 7.90995C219.2 8.55995 219.98 9.18995 220.53 9.79995C221.08 10.4099 221.48 10.8499 221.71 11.1299L216.8 15.7399C216.56 15.4999 216.1 15.0899 215.41 14.4999C214.72 13.9099 213.83 13.3699 212.75 12.8699C211.67 12.3799 210.36 12.1299 208.82 12.1299C206.77 12.1299 205.26 12.6199 204.3 13.6099C203.33 14.5999 202.85 15.5799 202.85 16.5699C202.85 17.9499 203.41 19.0799 204.53 19.9699C205.65 20.8599 207.83 21.6399 211.06 22.2999C213.11 22.7299 215.03 23.4299 216.82 24.3999C218.61 25.3699 220.06 26.7099 221.17 28.4199C222.27 30.1299 222.83 32.3299 222.83 35.0099C222.83 37.2999 222.22 39.3599 221 41.1899C219.78 43.0199 218.09 44.4699 215.94 45.5399C213.79 46.6099 211.36 47.1399 208.64 47.1399C205.92 47.1399 203.74 46.7499 201.75 45.9599C199.76 45.1699 198.06 44.1999 196.67 43.0299C195.27 41.8699 194.16 40.7699 193.33 39.7499V39.7399Z",
    fill: "#424142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4397 25.9301C12.5497 30.8901 16.5597 34.4501 21.2597 36.1401C17.7597 26.0001 15.1597 6.09011 40.0297 4.78011C34.8097 0.0901051 27.1397 -1.4399 20.2597 1.50011C10.7997 5.53011 6.39974 16.4701 10.4397 25.9401V25.9301Z",
    fill: "#B14FC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1097 50.3101C39.7197 47.6101 44.1697 43.1201 46.2297 37.7201C31.7097 48.6201 1.71971 40.4001 4.55971 11.2001C-0.080286 19.4801 -1.48029 29.5401 1.75971 37.5601C6.21971 48.5801 20.1297 57.0301 34.1097 50.3101Z",
    fill: "#2E368F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6094 12.9702C35.6094 15.9602 40.3394 20.1802 37.5394 38.7502C43.9494 34.1002 48.4194 28.5002 46.7694 20.3702C44.5094 9.19016 31.8594 7.25016 26.6094 12.9702Z",
    fill: "#8EC640"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_319_774"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 222.84,
    height: 52.7,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMfhsLogo);
export default __webpack_public_path__ + "static/media/mfhs-logo.2129a10c2cc5af8a5a07465de1bd633d.svg";
export { ForwardRef as ReactComponent };